import type { FormRules } from 'element-plus'

/** Add length checks while retaining each form's required and business validators. */
export function withLiveInputLimits(rules: FormRules, limits: Record<string, number>): FormRules {
  const result: FormRules = { ...rules }
  for (const [field, max] of Object.entries(limits)) {
    const existing = result[field]
    result[field] = [
      ...(Array.isArray(existing) ? existing : existing ? [existing] : []),
      { max, message: `最多输入${max}个字符`, trigger: ['blur', 'change'] }
    ]
  }
  return result
}
